<template>
  <div class="mt-4 text-black tab-content">
    <v-col class="flex-wrap" cols="12">
      <div class="mt-4 mb-3" style="font-size: 32px">
        Event & Lane Settings
      </div>
    </v-col>

    <v-col class="flex-wrap" cols="12">
      <div>
        <v-row class="flex-wrap align-center pb-2" style="padding-left: 4px">
          <v-col cols="4" xs4 class="align-left">
            Name
          </v-col>

          <v-col cols="1" xs1 class="text-center justify-center">
            Color
          </v-col>
        </v-row>

        <workflow-settings-basic-definition
          v-for="definition in definitions"
          :key="definition.id"
          :definition="definition"
          :disabled="$store.state.isWorkflowDisabled"
          @update-definition="updateWorkflowEntityDefinition"
        ></workflow-settings-basic-definition>
      </div>
    </v-col>
  </div>
</template>

<script>
import WorkflowSettingsBasicDefinition from '@/components/WorkflowSettingsBasicDefinition'
import workflowApi from '@/api/workflowApi'

export default {
  components: {
    WorkflowSettingsBasicDefinition
  },

  props: {
    workflow: Object
  },

  computed: {
    definitions () {
      if (!this.workflow) {
        return []
      }

      const { roleDefinition, eventDefinition } = this.workflow

      return [
        { id: 'EVENT', ...eventDefinition },
        { id: 'ROLE', ...roleDefinition }
      ]
    }
  },

  methods: {
    async updateWorkflowEntityDefinition (entityKind, input) {
      const inputVariables = {
        id: this.$route.params.id,
        expectedVersion: this.workflow.version
      }
      if (entityKind === 'EVENT') {
        inputVariables.eventDescription = input.description
        inputVariables.eventColor = input.color
      } else { // 'ROLE'
        inputVariables.roleDescription = input.description
        inputVariables.roleColor = input.color
      }
      await workflowApi.updateWorkflowNoHistoryMutation(
        this.$route.params.projectId,
        { ...inputVariables }
      )
    }
  }
}
</script>

<style scoped>
.tab-content {
  height: 900px;
}
</style>
